import React from 'react';
import venues from '../data/venues';

/**
 * Venue Filters Component
 *
 * Each Venue has a corresponding id for the TicketmasterApi
 * create option for for each venue object from venues.js
 */
const venueFilters = (props) => (
	<div className="venue-filter">
		<label htmlFor="venue_filter" className="form-label">Filter By Venue</label>
		<select onChange={props.onChange} id="venue_filter" className="venue-filter__select">
			{venues.map( (venue, index) => {
				return (
					<option value={venue.value} key={index}>{venue.name}</option>
				)
			})}
		</select>
	</div>
);

export default venueFilters;
